import {
  COMPANY_DETAILS_PAGE_PATH,
  INTERNAL_SEARCH_EXPLORE_PAGE_PATH,
  JOB_DETAILS_PAGE_PATH,
  SOURCED_JOB_DETAILS_PAGE_PATH,
} from 'src/common/constants';

export const VALID_RELOAD_PATHS = [
  JOB_DETAILS_PAGE_PATH,
  SOURCED_JOB_DETAILS_PAGE_PATH,
  INTERNAL_SEARCH_EXPLORE_PAGE_PATH,
  COMPANY_DETAILS_PAGE_PATH,
];

export const APPLY_PATH_SEGMENT = 'apply';

export const shouldReloadAfterLogin = (pathname: string): boolean => {
  const isValidPath = VALID_RELOAD_PATHS.some((validPath) =>
    pathname.startsWith(validPath)
  );

  return isValidPath;
};
